import type { ServiceAgreementContactNote } from 'pco-product-service-internal-consumer';
import type { LinkedContactNote } from '../LinkedContactNotesGrid';

export const toLinkedContactNote = (contactNote: ServiceAgreementContactNote): LinkedContactNote => ({
  contactNoteId: contactNote.contactNoteId ?? '',
  uid: contactNote.contactNoteUid,
  startDateTime: contactNote.startDateTime,
  subject: contactNote.subject,
  contactType: contactNote.contactType,
  status: contactNote.status,
  qualifiedClientContact: contactNote.qualifiedClientContact,
});

export const toContactNoteUids = (contactNotes: LinkedContactNote[]): string[] =>
  contactNotes.map((contactNote) => contactNote.uid).filter((uid): uid is string => !!uid);
